function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDiscussionRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 24V10H4v14h5.828l.586.586L13 27.172l2.586-2.586.586-.586H22zm0-16a2 2 0 012 2v14a2 2 0 01-2 2h-5l-4 4-4-4H4a2 2 0 01-2-2V10a2 2 0 012-2h18z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 16h12v-2H7v2zM7 21h6v-2H7v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 2H10a2 2 0 00-2 2v2h2V4h18v14h-2v2h2a2 2 0 002-2V4a2 2 0 00-2-2z",
    fill: props.color
  }));
}

export default SvgIconDiscussionRexOutline;